var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _g2, _path33, _path34, _path35, _g3, _path36, _path37, _path38, _g4, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g5, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _g6, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 566,
    viewBox: "0 0 649 566",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2139 450.986H603.351",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2139 339.444H603.351",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2139 227.902H603.351",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2139 116.36H603.351",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.164 53.0244V451.25",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M502.275 53.0244V451.25",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.319 200.642L156.934 205.261",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.997 121.885L166.596 195.072",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240.324 133.798L201.34 173.863",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M517.433 200.642L513.048 205.261",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M592.096 121.885L522.709 195.072",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M596.438 133.798L557.454 173.863",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3851 425.889L1 430.508",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0487 347.118L10.6619 420.32",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.39 359.031L45.3918 399.111",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7714 105.353L58.4009 109.972",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.45 26.582L68.0627 99.7693",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.776 38.4951L102.793 78.5603",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387.268 105.353L382.898 109.972",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M461.947 26.582L392.56 99.7693",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M466.273 38.4951L427.29 78.5603",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M286.938 316.51L282.552 321.129",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.601 237.754L292.214 310.941",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M365.942 249.667L326.959 289.732",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M586.118 533.412C586.118 533.412 549.926 456.292 557.79 454.071C565.654 451.849 582.142 464.127 582.142 464.127C582.142 464.127 533.76 334.474 546.287 324.418C558.813 314.361 582.201 365.828 582.201 365.828C582.201 365.828 557.22 286.414 560.158 256.2C563.096 225.987 594.83 255.09 594.83 255.09C594.83 255.09 569.411 146.675 593.017 141.077C616.624 135.479 615.834 265.131 615.834 265.131C615.834 265.131 623.581 172.357 633.039 198.069C642.496 223.78 622.617 309.83 622.617 309.83C622.617 309.83 635.582 280.772 642.788 307.594C649.994 334.416 628.463 442.83 628.463 442.83C628.463 442.83 646.764 424.954 648.474 447.303C650.184 469.652 610.587 538.951 610.587 538.951L588.179 541.232L586.118 533.412Z",
    fill: "#92E3A9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M586.118 533.412C586.118 533.412 549.926 456.292 557.79 454.071C565.654 451.849 582.142 464.127 582.142 464.127C582.142 464.127 533.76 334.474 546.287 324.418C558.813 314.361 582.201 365.828 582.201 365.828C582.201 365.828 557.22 286.414 560.158 256.2C563.096 225.987 594.83 255.09 594.83 255.09C594.83 255.09 569.411 146.675 593.017 141.077C616.624 135.479 615.834 265.131 615.834 265.131C615.834 265.131 623.581 172.357 633.039 198.069C642.496 223.78 622.617 309.83 622.617 309.83C622.617 309.83 635.582 280.772 642.788 307.594C649.994 334.416 628.463 442.83 628.463 442.83C628.463 442.83 646.764 424.954 648.474 447.303C650.184 469.652 610.587 538.951 610.587 538.951L588.179 541.232L586.118 533.412Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M593.85 536.846C593.85 536.846 563.681 483.202 569.265 473.131C574.848 463.06 591.614 486.549 591.614 486.549C591.614 486.549 553.61 391.539 559.208 382.608C564.806 373.677 582.683 412.792 582.683 412.792C582.683 412.792 575.974 282.028 587.141 286.487C598.309 290.945 599.39 353.476 599.39 353.476C599.39 353.476 592.696 204.836 602.752 209.309C612.809 213.782 611.698 379.188 611.698 379.188C611.698 379.188 631.811 315.472 635.158 344.531C638.505 373.589 609.461 451.834 609.461 451.834C609.461 451.834 637.394 390.355 640.8 422.834C644.206 455.313 618.392 515.535 618.392 515.535C618.392 515.535 628.449 490.949 628.449 504.353C628.449 517.757 620.629 534.537 620.629 534.537",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M510.84 370.564L551.549 459.406L525.94 466.627L495.741 429.032L510.84 370.564Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 495,
    y: 370,
    width: 57,
    height: 97
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M510.84 370.564L551.549 459.406L525.94 466.627L495.741 429.032L510.84 370.564Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_1676)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.488 399.009L501.763 405.718L535.572 463.908L540.425 462.549L503.488 399.009Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.13 466.583L531.012 465.209L499.556 414.24L497.875 420.774L526.13 466.583Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.669 382.828L505.885 389.756L544.708 461.335L549.502 459.976L507.669 382.828Z",
    fill: "black"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M510.84 370.564L551.549 459.406L525.94 466.627L495.741 429.032L510.84 370.564Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M429.877 345.817L376.861 370.242L405.13 484.942L396.126 533.193H496.706L486.752 480.761L511.162 370.564L455.574 347.747L429.877 345.817Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 376,
    y: 345,
    width: 136,
    height: 189
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M429.877 345.817L376.861 370.242L405.13 484.942L396.126 533.193H496.706L486.752 480.761L511.162 370.564L455.574 347.747L429.877 345.817Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_159_1676)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.359 533.192L432.391 487.499C432.413 487.286 432.413 487.07 432.391 486.856L411.562 354.266L405.423 357.087L425.887 487.543L423.855 533.192H430.359Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.55 476.566C442.55 476.566 442.55 476.449 442.55 476.391L426.033 347.586L419.85 350.509L436.075 477.195L440.255 533.265H446.774L442.55 476.566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.971 533.192L417.818 488.596C417.869 488.267 417.869 487.931 417.818 487.602L395.527 361.677L389.432 364.483L411.357 488.245L405.51 533.192H411.971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.853 369.614L502.728 367.1L480.379 482.676C480.313 483.053 480.313 483.439 480.379 483.816L488.418 533.192H495.01L486.839 483.348L487.029 482.398L486.708 480.761L491.605 458.704L508.853 369.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.268 358.943L443.778 359.133L449.171 533.192H455.661L450.268 358.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.056 482.5L494.645 363.781L488.506 361.252L466.58 481.901C466.507 482.273 466.507 482.655 466.58 483.027L475.146 533.192H481.738L473.056 482.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.26 478.466L477.675 356.809L471.462 354.266L454.77 477.998C454.734 478.26 454.734 478.526 454.77 478.788L460.821 533.192H467.355L461.26 478.466Z",
    fill: "black"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M429.877 345.817L376.861 370.242L405.13 484.942L396.126 533.193H496.706L486.752 480.761L511.162 370.564L455.574 347.747L429.877 345.817Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M376.861 370.242L335.1 460.678L361.762 466.305L391.961 428.71L376.861 370.242Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 335,
    y: 370,
    width: 57,
    height: 97
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M376.861 370.242L335.1 460.678L361.762 466.305L391.961 428.71L376.861 370.242Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_159_1676)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.839 412.749L358.751 465.677L361.762 466.305L368.72 457.637L389.607 419.633L387.839 412.749Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.222 402.634L383.322 395.267L350.858 464.01L355.754 465.048L385.222 402.634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.26 461.759L345.157 462.797L381.071 386.54L379.156 379.144L340.26 461.759Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375.765 385.298L390.499 424.837L375.706 402.195",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M376.861 370.242L335.1 460.678L361.762 466.305L391.961 428.71L376.861 370.242Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M363.677 452.813L416.371 512.904L406.139 524.466L339.734 471.582C339.734 471.582 330.628 467.197 336.094 458.28",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 334,
    y: 452,
    width: 83,
    height: 73
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M363.677 452.813L416.371 512.904L406.139 524.466L339.734 471.582C339.734 471.582 330.628 467.197 336.094 458.28",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_159_1676)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.846 517.084L415.786 512.86L389.212 481.93L363.677 452.813L356.807 454.173L410.846 517.084Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.321 519.862L404.721 523.37L408.858 519.73L352.027 455.123L344.66 456.57L400.321 519.862Z",
    fill: "black"
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M363.677 452.813L416.371 512.904L406.139 524.466L339.734 471.582C339.734 471.582 330.628 467.197 336.094 458.28",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M407.908 510.638C409.369 509.82 434.788 503.739 435.139 506.853C435.49 509.966 443.061 513.401 446.511 513.401C449.961 513.401 453.41 510.638 454.097 514.775C454.784 518.912 450.998 519.262 447.9 519.599C444.801 519.935 434.101 516.5 434.101 516.5C434.101 516.5 424.103 524.773 419.967 526.834C415.83 528.895 408.273 528.296 405.496 526.147C402.719 523.998 398.962 515.462 407.908 510.638Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M431.368 506.502C431.368 506.502 441.015 503.739 443.062 504.777C445.108 505.815 446.175 526.498 446.175 526.498C446.175 526.498 445.137 528.559 443.062 526.498C440.986 524.437 434.101 508.958 434.101 508.958",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M431.368 506.502C431.368 506.502 441.015 503.739 443.062 504.777C445.108 505.815 446.175 526.498 446.175 526.498C446.175 526.498 445.137 528.559 443.062 526.498C440.986 524.437 434.101 508.958 434.101 508.958",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M426.53 507.189C426.53 507.189 436.528 504.777 438.603 508.563C440.679 512.349 445.839 529.246 441.702 529.947C437.565 530.649 436.191 525.109 436.191 525.109L429.643 513.05L425.156 512.363",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M426.53 507.189C426.53 507.189 436.528 504.777 438.603 508.563C440.679 512.349 445.839 529.246 441.702 529.947C437.565 530.649 436.191 525.109 436.191 525.109L429.643 513.05L425.156 512.363",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M423.095 510.288C423.095 510.288 427.918 508.227 430.33 509.951C432.742 511.676 443.778 529.246 441.702 529.947C439.627 530.649 434.803 530.284 434.116 528.91C433.429 527.536 424.469 515.754 424.469 515.754",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M423.095 510.288C423.095 510.288 427.918 508.227 430.33 509.951C432.742 511.676 443.778 529.246 441.702 529.947C439.627 530.649 434.803 530.284 434.116 528.91C433.429 527.536 424.469 515.754 424.469 515.754",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M419.601 516.149C419.601 516.149 424.074 512.013 426.486 513.401C428.898 514.79 438.896 527.872 436.835 529.246C434.774 530.62 433.385 529.246 431.324 526.498C429.846 524.645 428.102 523.019 426.15 521.674L422.013 523.048",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M419.601 516.149C419.601 516.149 424.074 512.013 426.486 513.401C428.898 514.79 438.896 527.872 436.835 529.246C434.774 530.62 433.385 529.246 431.324 526.498C429.846 524.645 428.102 523.019 426.15 521.674L422.013 523.048",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M521.452 454.743L503.912 514.424L516.6 523.282L545.263 477.21C545.263 477.21 557.045 463.908 549.649 456.424",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 503,
    y: 454,
    width: 50,
    height: 70
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M521.452 454.743L503.912 514.424L516.6 523.282L545.263 477.21C545.263 477.21 557.045 463.908 549.649 456.424",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_159_1676)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.994 522.566L517.213 522.201L541.492 455.942L534.71 455.533L511.25 519.584L513.881 521.411L516.994 522.566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.941 514.468L509.452 518.327L532.108 455.562L531.48 455.342L525.414 454.977L503.941 514.468Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.651 459.918C551.263 458.598 550.549 457.397 549.575 456.424L546.097 456.22L527.767 505.318L545.19 477.283L551.651 459.918Z",
    fill: "black"
  })))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M521.452 454.743L503.912 514.424L516.6 523.282L545.263 477.21C545.263 477.21 557.045 463.908 549.649 456.424",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M512.741 510.638C511.279 509.82 485.845 503.739 485.509 506.853C485.173 509.966 477.572 513.401 474.137 513.401C470.702 513.401 467.238 510.638 466.551 514.775C465.864 518.912 469.65 519.262 472.749 519.599C475.847 519.935 486.547 516.5 486.547 516.5C486.547 516.5 496.545 524.773 500.682 526.834C504.818 528.895 512.375 528.296 515.152 526.147C517.93 523.998 521.701 515.462 512.741 510.638Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M489.295 506.502C489.295 506.502 479.648 503.739 477.601 504.777C475.555 505.815 474.503 526.498 474.503 526.498C474.503 526.498 475.54 528.559 477.601 526.498C479.662 524.437 486.576 508.958 486.576 508.958",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M489.295 506.502C489.295 506.502 479.648 503.739 477.601 504.777C475.555 505.815 474.503 526.498 474.503 526.498C474.503 526.498 475.54 528.559 477.601 526.498C479.662 524.437 486.576 508.958 486.576 508.958",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M494.148 507.189C494.148 507.189 484.164 504.777 482.089 508.563C480.013 512.349 474.78 529.246 478.99 529.947C483.2 530.649 484.501 525.109 484.501 525.109L491.049 513.05L495.537 512.363",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M494.148 507.189C494.148 507.189 484.164 504.777 482.089 508.563C480.013 512.349 474.78 529.246 478.99 529.947C483.2 530.649 484.501 525.109 484.501 525.109L491.049 513.05L495.537 512.363",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M497.568 510.288C497.568 510.288 492.745 508.227 490.333 509.951C487.921 511.676 476.885 529.246 478.961 529.947C481.036 530.649 485.845 530.284 486.547 528.91C487.249 527.536 496.194 515.754 496.194 515.754",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M497.568 510.288C497.568 510.288 492.745 508.227 490.333 509.951C487.921 511.676 476.885 529.246 478.961 529.947C481.036 530.649 485.845 530.284 486.547 528.91C487.249 527.536 496.194 515.754 496.194 515.754",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M501.018 516.149C501.018 516.149 496.545 511.998 494.148 513.46C491.751 514.921 481.738 527.931 483.814 529.305C485.889 530.679 487.263 529.305 489.324 526.557C490.803 524.703 492.546 523.078 494.499 521.733L498.635 523.107",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M501.018 516.149C501.018 516.149 496.545 511.998 494.148 513.46C491.751 514.921 481.738 527.931 483.814 529.305C485.889 530.679 487.263 529.305 489.324 526.557C490.803 524.703 492.546 523.078 494.499 521.733L498.635 523.107",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M433.721 339.707C433.721 339.707 425.375 342.28 421.838 347.425C418.3 352.57 422.481 392.402 422.481 392.402L449.157 377.624L477.104 395.296C477.104 395.296 474.532 354.5 472.281 348.712C470.03 342.923 455.895 336.185 451.072 336.828C446.248 337.471 433.721 339.707 433.721 339.707Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M429.877 317.548V354.5L447.549 402.049L462.648 353.535V317.227L429.877 317.548Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M429.833 330.82C434.821 334.32 440.769 336.194 446.862 336.185C452.432 336.189 457.889 334.619 462.604 331.654V317.227L429.833 317.592V330.82Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M446.906 327.824C439.011 327.824 431.44 324.689 425.857 319.108C420.273 313.528 417.135 305.958 417.131 298.064L411.883 256.201C411.883 246.897 415.579 237.974 422.158 231.395C428.737 224.816 437.66 221.12 446.964 221.12C456.268 221.12 465.191 224.816 471.77 231.395C478.349 237.974 482.045 246.897 482.045 256.201L476.607 298.005C476.615 301.914 475.853 305.785 474.364 309.399C472.876 313.012 470.69 316.297 467.932 319.066C465.174 321.835 461.898 324.034 458.29 325.536C454.682 327.039 450.814 327.816 446.906 327.824Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M454.55 286.604C454.55 286.604 462.137 280.246 471.199 287.101",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M440.84 285.873C438.587 284.438 435.904 283.834 433.253 284.163",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M457.489 271.432C457.489 271.432 465.572 267.514 470.468 275.1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M444.45 303.501C444.45 303.501 447.885 306.191 450.823 303.501",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M441.088 309.377C441.088 309.377 448.192 313.763 452.343 309.377",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M461.874 251.816C461.874 251.816 432.523 278.916 424.337 298.663C416.152 318.411 423.489 339.035 428.006 344.97C432.523 350.904 435.315 351.737 435.315 351.737C435.315 351.737 419.791 357.672 409.633 342.149C399.474 326.625 402.002 309.114 405.116 296.982C408.229 284.85 407.367 249.272 414.427 237.418C421.487 225.564 431.646 216.808 448.587 218.781C465.528 220.755 474.547 229.51 479.911 240.517C485.275 251.523 482.732 270.16 484.428 278.346C486.123 286.531 493.461 311.088 495.157 325.763C496.852 340.439 476.841 350.89 473.684 352.308C471.538 353.21 469.243 353.706 466.916 353.769C466.916 353.769 473.684 319.902 475.102 300.417C476.52 280.933 476.608 269.356 476.608 269.356C476.608 269.356 463.292 252.664 461.874 251.816Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_159_1676",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 402,
    y: 218,
    width: 94,
    height: 136
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M461.874 251.816C461.874 251.816 432.523 278.916 424.337 298.663C416.152 318.411 423.489 339.035 428.006 344.97C432.523 350.904 435.315 351.737 435.315 351.737C435.315 351.737 419.791 357.672 409.633 342.149C399.474 326.625 402.002 309.114 405.116 296.982C408.229 284.85 407.367 249.272 414.427 237.418C421.487 225.564 431.646 216.808 448.587 218.781C465.528 220.755 474.547 229.51 479.911 240.517C485.275 251.523 482.732 270.16 484.428 278.346C486.123 286.531 493.461 311.088 495.157 325.763C496.852 340.439 476.841 350.89 473.684 352.308C471.538 353.21 469.243 353.706 466.916 353.769C466.916 353.769 473.684 319.902 475.102 300.417C476.52 280.933 476.608 269.356 476.608 269.356C476.608 269.356 463.292 252.664 461.874 251.816Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_159_1676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.439 232.813C458.439 232.813 454.974 242.358 430.052 269.707C405.13 297.055 398.363 323.146 405.934 348.638",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.285 223.283C452.285 223.283 438.574 234.64 421.589 251.654C411.15 262.187 402.235 274.128 395.103 287.13",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.578 235.108C464.578 235.108 474.985 254.022 480.656 265.38C486.328 276.737 492.964 340.569 473.099 363.313",
    stroke: "#707070",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.489 219.497L461.874 251.815",
    stroke: "#707070",
    strokeMiterlimit: 10
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M461.874 251.816C461.874 251.816 432.523 278.916 424.337 298.663C416.152 318.411 423.489 339.035 428.006 344.97C432.523 350.904 435.315 351.737 435.315 351.737C435.315 351.737 419.791 357.672 409.633 342.149C399.474 326.625 402.002 309.114 405.116 296.982C408.229 284.85 407.367 249.272 414.427 237.418C421.487 225.564 431.646 216.808 448.587 218.781C465.528 220.755 474.547 229.51 479.911 240.517C485.275 251.523 482.732 270.16 484.428 278.346C486.123 286.531 493.461 311.088 495.157 325.763C496.852 340.439 476.841 350.89 473.684 352.308C471.538 353.21 469.243 353.706 466.916 353.769C466.916 353.769 473.684 319.902 475.102 300.417C476.52 280.933 476.608 269.356 476.608 269.356C476.608 269.356 463.292 252.664 461.874 251.816Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M408.989 270.73H404.663C402.273 270.73 400.336 272.667 400.336 275.057V292.378C400.336 294.767 402.273 296.704 404.663 296.704H408.989C411.379 296.704 413.316 294.767 413.316 292.378V275.057C413.316 272.667 411.379 270.73 408.989 270.73Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M488.316 270.73H483.989C481.599 270.73 479.662 272.667 479.662 275.057V292.378C479.662 294.767 481.599 296.704 483.989 296.704H488.316C490.705 296.704 492.642 294.767 492.642 292.378V275.057C492.642 272.667 490.705 270.73 488.316 270.73Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M487.278 270.73V256.61C487.278 245.682 482.937 235.201 475.209 227.474C467.482 219.746 457.001 215.405 446.073 215.405C435.143 215.405 424.661 219.746 416.931 227.473C409.201 235.2 404.857 245.68 404.853 256.61V270.73",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M486.152 296.573C486.152 296.573 484.325 310.708 467.033 316.467",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M466.376 315.853C467.106 317.972 465.045 320.603 461.757 321.699C458.468 322.796 455.237 322.05 454.448 319.931C453.659 317.811 455.778 315.18 459.052 314.084C462.327 312.988 465.689 313.733 466.376 315.853Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M170.528 334.08L110.13 362.861L127.554 533.543H247.954L264.983 360.025L208.225 333.67L170.528 334.08Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M194.734 386.16C195.864 386.16 196.78 385.244 196.78 384.114C196.78 382.984 195.864 382.067 194.734 382.067C193.603 382.067 192.687 382.984 192.687 384.114C192.687 385.244 193.603 386.16 194.734 386.16Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 396.392C196.78 396.797 196.66 397.192 196.435 397.529C196.21 397.866 195.891 398.128 195.517 398.283C195.143 398.438 194.731 398.478 194.334 398.399C193.937 398.32 193.573 398.125 193.287 397.839C193 397.553 192.806 397.188 192.727 396.791C192.648 396.394 192.688 395.983 192.843 395.609C192.998 395.235 193.26 394.915 193.597 394.691C193.933 394.466 194.329 394.346 194.734 394.346C195.276 394.346 195.797 394.561 196.181 394.945C196.564 395.329 196.78 395.849 196.78 396.392Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M215.68 342.791L199.177 361.194L192.132 379.071L184.545 360.931L168.584 342.791V310.576H215.68V342.791Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M168.584 324.9C171.69 328.677 175.596 331.717 180.019 333.803C184.443 335.888 189.273 336.966 194.163 336.959C202.056 336.969 209.69 334.148 215.68 329.008V310.576H168.584V324.9Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M197.482 220.418H190.845C174.361 220.418 160.998 233.781 160.998 250.266V298.049C160.998 314.533 174.361 327.897 190.845 327.897H197.482C213.966 327.897 227.329 314.533 227.329 298.049V250.266C227.329 233.781 213.966 220.418 197.482 220.418Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M200.522 268.069L199.543 291.559C199.523 292.577 199.192 293.564 198.593 294.388C197.995 295.211 197.158 295.831 196.195 296.163C194.427 296.704 192.41 296.163 191.313 292.173",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M181.344 300.826H207.655C207.655 300.826 203.051 310.853 194.12 310.853C185.189 310.853 181.344 300.826 181.344 300.826Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M183.215 304.349H205.375C206.217 303.248 206.951 302.068 207.567 300.826H181.344C181.844 302.062 182.471 303.243 183.215 304.349Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M181.037 278.638C182.087 278.638 182.938 276.635 182.938 274.165C182.938 271.694 182.087 269.692 181.037 269.692C179.988 269.692 179.137 271.694 179.137 274.165C179.137 276.635 179.988 278.638 181.037 278.638Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M209.453 278.638C210.502 278.638 211.353 276.635 211.353 274.165C211.353 271.694 210.502 269.692 209.453 269.692C208.403 269.692 207.553 271.694 207.553 274.165C207.553 276.635 208.403 278.638 209.453 278.638Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M203.504 262.384C203.504 262.384 209.994 258.32 217.317 264.825",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M194.164 220.418C185.367 220.418 176.931 223.912 170.712 230.132C164.492 236.352 160.998 244.788 160.998 253.584V283.797H161.275H163.979V271.344C163.979 271.344 177.515 271.344 193.491 262.69C209.467 254.037 213.502 239.917 213.502 239.917C213.502 239.917 217.024 256.975 220.81 260.22L224.611 263.465V284.046H227.315V253.584C227.315 244.79 223.823 236.357 217.606 230.137C211.389 223.918 202.957 220.422 194.164 220.418Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M154.785 267.807H160.997V292.436H154.785C153.204 292.436 151.687 291.808 150.568 290.69C149.45 289.571 148.822 288.054 148.822 286.473V273.741C148.829 272.165 149.461 270.655 150.579 269.543C151.696 268.431 153.209 267.807 154.785 267.807Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M233.147 292.436H226.935V267.806H233.147C233.93 267.806 234.706 267.961 235.429 268.26C236.153 268.56 236.81 268.999 237.364 269.553C237.918 270.107 238.357 270.764 238.657 271.488C238.957 272.211 239.111 272.987 239.111 273.77V286.502C239.103 288.078 238.471 289.588 237.354 290.7C236.236 291.812 234.724 292.436 233.147 292.436Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M155.589 267.806V252.093C155.589 241.897 159.64 232.119 166.849 224.91C174.058 217.701 183.836 213.65 194.032 213.65C204.226 213.654 214.002 217.706 221.211 224.914C228.419 232.123 232.471 241.899 232.475 252.093V267.806",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M232.504 292.436C232.504 292.436 230.604 307.053 212.742 313.017",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M212.04 312.374C212.8 314.566 210.666 317.285 207.275 318.469C203.884 319.653 200.522 318.82 199.762 316.627C199.002 314.435 201.136 311.716 204.527 310.532C207.918 309.348 211.324 310.181 212.04 312.374Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.131 362.861L59.0442 470.953L80.1219 489.342L118.228 441.515L110.131 362.861Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M105.935 395.997L118.345 437.86L103.611 413.815",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M264.983 360.025L313.628 468.673L283.634 481.653L256.87 438.679L264.983 360.025Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6118 468.264L130.39 509.206L118.228 523.399L54.5859 483.919L61.8944 464.463",
    fill: "#92E3A9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6118 468.264L130.39 509.206L118.228 523.399L54.5859 483.919L61.8944 464.463",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M123.096 506.779C124.879 505.815 154.712 498.667 155.122 502.321C155.531 505.976 164.447 510.024 168.496 510.024C172.545 510.024 176.609 506.779 177.413 511.647C178.216 516.514 173.773 516.909 170.104 517.318C166.435 517.728 153.894 513.664 153.894 513.664C153.894 513.664 142.2 523.399 137.274 525.84C132.348 528.281 123.49 527.448 120.246 525.021C117.001 522.595 112.557 512.451 123.096 506.779Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M150.649 501.912C150.649 501.912 162.006 498.667 164.432 499.895C166.859 501.123 168.087 525.431 168.087 525.431C168.087 525.431 166.859 527.857 164.432 525.431C162.006 523.005 153.908 504.69 153.908 504.69",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M150.649 501.912C150.649 501.912 162.006 498.667 164.432 499.895C166.859 501.123 168.087 525.431 168.087 525.431C168.087 525.431 166.859 527.857 164.432 525.431C162.006 523.005 153.908 504.69 153.908 504.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M144.992 502.731C144.992 502.731 156.686 499.895 159.171 504.353C161.655 508.811 167.692 528.676 162.825 529.48C157.957 530.284 156.335 523.808 156.335 523.808L148.632 509.615L143.37 508.811",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M144.992 502.731C144.992 502.731 156.686 499.895 159.171 504.353C161.655 508.811 167.692 528.676 162.825 529.48C157.957 530.284 156.335 523.808 156.335 523.808L148.632 509.615L143.37 508.811",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M140.928 506.37C140.928 506.37 146.614 503.944 149.45 505.975C152.286 508.007 165.266 528.676 162.825 529.538C160.384 530.4 154.712 529.947 153.908 528.325C153.104 526.702 142.551 512.919 142.551 512.919",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M140.928 506.37C140.928 506.37 146.614 503.944 149.45 505.975C152.286 508.007 165.266 528.676 162.825 529.538C160.384 530.4 154.712 529.947 153.908 528.325C153.104 526.702 142.551 512.919 142.551 512.919",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M136.88 513.269C136.88 513.269 142.156 508.402 144.992 510.024C147.828 511.646 159.609 527.053 157.153 528.675C154.698 530.298 153.09 528.675 150.663 525.43C148.927 523.247 146.878 521.331 144.583 519.744L139.715 521.367",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M136.88 513.269C136.88 513.269 142.156 508.402 144.992 510.024C147.828 511.646 159.609 527.053 157.153 528.675C154.698 530.298 153.09 528.675 150.663 525.43C148.927 523.247 146.878 521.331 144.583 519.744L139.715 521.367",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M276.282 457.915L250.614 512.085L267.131 520.812L315.674 469.375L301.744 453.954",
    fill: "#92E3A9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M276.282 457.915L250.614 512.085L267.131 520.812L315.674 469.375L301.744 453.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M263.463 506.779C261.679 505.815 231.831 498.667 231.437 502.321C231.042 505.976 222.111 510.024 218.048 510.024C213.984 510.024 209.95 506.779 209.131 511.647C208.313 516.514 212.785 516.909 216.44 517.318C220.094 517.728 232.65 513.664 232.65 513.664C232.65 513.664 244.344 523.399 249.269 525.84C254.195 528.281 263.053 527.448 266.298 525.021C269.543 522.595 274.001 512.451 263.463 506.779Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M235.895 501.912C235.895 501.912 224.538 498.667 222.111 499.895C219.685 501.123 218.457 525.431 218.457 525.431C218.457 525.431 219.67 527.857 222.111 525.431C224.552 523.005 232.65 504.69 232.65 504.69",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M235.895 501.912C235.895 501.912 224.538 498.667 222.111 499.895C219.685 501.123 218.457 525.431 218.457 525.431C218.457 525.431 219.67 527.857 222.111 525.431C224.552 523.005 232.65 504.69 232.65 504.69",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M241.567 502.731C241.567 502.731 229.873 499.895 227.373 504.353C224.874 508.811 218.866 528.676 223.734 529.538C228.601 530.401 230.209 523.867 230.209 523.867L237.912 509.674L243.189 508.87",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M241.567 502.731C241.567 502.731 229.873 499.895 227.373 504.353C224.874 508.811 218.866 528.676 223.734 529.538C228.601 530.401 230.209 523.867 230.209 523.867L237.912 509.674L243.189 508.87",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M245.659 506.37C245.659 506.37 239.988 503.944 237.152 505.975C234.316 508.007 221.293 528.676 223.734 529.538C226.175 530.4 231.832 529.947 232.65 528.325C233.469 526.702 243.993 512.919 243.993 512.919",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M245.659 506.37C245.659 506.37 239.988 503.944 237.152 505.975C234.316 508.007 221.293 528.676 223.734 529.538C226.175 530.4 231.832 529.947 232.65 528.325C233.469 526.702 243.993 512.919 243.993 512.919",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M249.679 513.269C249.679 513.269 244.402 508.402 241.566 510.024C238.731 511.646 226.95 527.053 229.405 528.675C231.861 530.298 233.454 528.675 235.895 525.43C237.632 523.247 239.681 521.331 241.976 519.744L246.843 521.367",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M249.679 513.269C249.679 513.269 244.402 508.402 241.566 510.024C238.731 511.646 226.95 527.053 229.405 528.675C231.861 530.298 233.454 528.675 235.895 525.43C237.632 523.247 239.681 521.331 241.976 519.744L246.843 521.367",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M340.173 158.574H245.162C240.757 158.574 236.532 160.323 233.416 163.436C230.299 166.55 228.547 170.773 228.543 175.179V202.951C228.531 205.138 228.952 207.306 229.78 209.331C230.608 211.356 231.828 213.197 233.369 214.749C234.91 216.301 236.743 217.534 238.762 218.376C240.78 219.219 242.946 219.654 245.133 219.658H256.827L240.879 240.517L276.735 219.658H340.173C342.355 219.652 344.515 219.217 346.529 218.376C348.543 217.536 350.372 216.307 351.912 214.759C353.451 213.212 354.67 211.377 355.5 209.358C356.33 207.34 356.754 205.177 356.748 202.995V175.222C356.756 170.817 355.015 166.589 351.906 163.467C348.798 160.345 344.578 158.585 340.173 158.574Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M279.614 191.023C279.617 191.79 279.393 192.54 278.969 193.179C278.545 193.818 277.941 194.317 277.233 194.612C276.526 194.908 275.747 194.987 274.994 194.839C274.242 194.691 273.55 194.323 273.007 193.782C272.464 193.241 272.094 192.551 271.943 191.799C271.792 191.047 271.868 190.268 272.161 189.559C272.454 188.85 272.95 188.245 273.587 187.818C274.225 187.392 274.974 187.165 275.741 187.165C276.766 187.165 277.749 187.571 278.475 188.294C279.201 189.017 279.611 189.999 279.614 191.023Z",
    fill: "#263238"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M296.512 191.023C296.515 191.791 296.289 192.542 295.865 193.181C295.44 193.82 294.836 194.319 294.127 194.614C293.419 194.909 292.639 194.987 291.886 194.838C291.133 194.689 290.442 194.32 289.899 193.777C289.357 193.234 288.987 192.543 288.838 191.79C288.689 191.037 288.767 190.257 289.062 189.549C289.357 188.841 289.856 188.236 290.495 187.811C291.134 187.387 291.885 187.162 292.653 187.165C293.676 187.165 294.658 187.571 295.381 188.295C296.105 189.019 296.512 190 296.512 191.023Z",
    fill: "#263238"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M313.409 191.023C313.409 191.787 313.183 192.533 312.759 193.167C312.335 193.802 311.732 194.297 311.027 194.589C310.322 194.881 309.546 194.957 308.797 194.808C308.049 194.659 307.361 194.292 306.821 193.752C306.282 193.212 305.914 192.525 305.765 191.776C305.616 191.028 305.693 190.252 305.985 189.547C306.277 188.842 306.772 188.239 307.406 187.815C308.041 187.391 308.787 187.165 309.55 187.165C310.573 187.165 311.555 187.571 312.279 188.295C313.002 189.018 313.409 190 313.409 191.023Z",
    fill: "#263238"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M534.271 529.144H357.201V536.291H534.271V529.144Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M561.474 529.144H407.133V536.291H561.474V529.144Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M564.47 516.441H416.809L432.727 403.701H580.388L564.47 516.441Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M570.58 516.441H422.919L438.837 403.701H586.498L570.58 516.441Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M525.326 464.04L540.148 536.277H502.041L487.234 464.04H525.326ZM499.483 485.483C499.555 485.776 499.725 486.037 499.963 486.223C500.202 486.408 500.496 486.508 500.799 486.506L522.388 486.301C522.59 486.298 522.789 486.25 522.97 486.159C523.151 486.069 523.309 485.938 523.433 485.778C523.557 485.618 523.643 485.432 523.684 485.234C523.726 485.036 523.723 484.831 523.674 484.635L521.73 476.537C521.658 476.242 521.49 475.979 521.251 475.791C521.013 475.603 520.718 475.5 520.415 475.499L498.825 475.704C498.623 475.707 498.423 475.756 498.242 475.847C498.061 475.937 497.902 476.067 497.777 476.227C497.652 476.386 497.565 476.572 497.521 476.77C497.478 476.968 497.479 477.173 497.524 477.37L499.483 485.483Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M272.364 529.144H95.2942V536.291H272.364V529.144Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M299.567 529.144H145.226V536.291H299.567V529.144Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M302.563 516.441H154.902L170.82 403.701H318.481L302.563 516.441Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M308.673 516.441H161.012L176.93 403.701H324.591L308.673 516.441Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M263.433 464.04L278.24 536.277H240.134L225.327 464.04H263.433ZM237.576 485.483C237.651 485.775 237.82 486.034 238.059 486.22C238.297 486.405 238.59 486.505 238.891 486.506L260.481 486.301C260.683 486.298 260.883 486.249 261.064 486.159C261.245 486.068 261.404 485.938 261.529 485.779C261.654 485.619 261.741 485.433 261.785 485.235C261.829 485.037 261.827 484.832 261.782 484.635L259.823 476.537C259.754 476.241 259.586 475.977 259.347 475.788C259.108 475.6 258.812 475.498 258.507 475.499L236.918 475.704C236.716 475.707 236.517 475.755 236.336 475.846C236.155 475.936 235.997 476.067 235.873 476.227C235.749 476.387 235.664 476.573 235.622 476.771C235.58 476.969 235.583 477.174 235.632 477.37L237.576 485.483Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M634.106 536.276H4.23047V543.351H634.106V536.276Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallCenter);
export default __webpack_public_path__ + "static/media/callCenter.5639d15191865d5452f320f74f557227.svg";
export { ForwardRef as ReactComponent };